module.exports = __webpack_public_path__ + "static/endurance-664554b686e69c7c952e86e4d3051b8c.jpg";